import { getGenderOption } from './helpers'

import { GENDER_OPTION } from '../../../../../ReusableFormFields/GenderFields/fields'

export const getInitialValues = targeting => {
  return {
    [GENDER_OPTION]: getGenderOption(targeting)
  }
}
